
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partnersignup",
      function () {
        return require("private-next-pages/partnersignup.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partnersignup"])
      });
    }
  